import { render, staticRenderFns } from "./MedicineInfo.vue?vue&type=template&id=21a491c6&scoped=true&"
import script from "./MedicineInfo.vue?vue&type=script&lang=js&"
export * from "./MedicineInfo.vue?vue&type=script&lang=js&"
import style0 from "./MedicineInfo.vue?vue&type=style&index=0&id=21a491c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a491c6",
  null
  
)

export default component.exports